<template>
  <v-row>
    <v-col cols="12">
      <div class=" layout">
        <v-card class="caja_titulo">
          <v-card-text>
            <h2>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                class="mr-2"
              >
                <path fill="none" d="M0 0h24v24H0V0z"></path>
                <path
                  d="M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"
                  style="fill: white;"
                ></path></svg
              >{{$t('primero.title_1')}}
            </h2>
          </v-card-text>
        </v-card>
      </div>
    </v-col>
    <v-col cols="12" offset-sm="2" sm="4">
      <v-text-field
        :label="$t('primero.field_1')"
        prepend-inner-icon="mdi-star"
        outlined
        required
        :rules="[reglas.required($t('primero.field_1'))]"
        v-model="modelo.empresa"
      />
    </v-col>
    <v-col cols="12" offset-sm="1" sm="4">
      <v-text-field
        :label="$t('primero.field_2')"
        prepend-inner-icon="mdi-account-box"
        outlined
        required
        :rules="[reglas.required($t('primero.field_2'))]"
        v-model="modelo.nombre"
      />
    </v-col>

    <v-col cols="12" offset-sm="2" sm="4">
      <v-text-field
        :label="$t('primero.field_3')"
        prepend-inner-icon="mdi-email"
        outlined
        required
        :rules="[reglas.required($t('primero.field_3')),reglas.email()]"
        v-model="modelo.email"
      />
    </v-col>
    <v-col cols="12" offset-sm="1" sm="4">
      <v-text-field
        :label="$t('primero.field_4')"
        prepend-inner-icon="mdi-phone"
        outlined
        required
        :rules="[reglas.required($t('primero.field_4'))]"
        v-model="modelo.telefono"
      />
    </v-col>

    <v-col cols="12" offset-sm="2" sm="4">
      <v-select
        :label="$t('primero.field_5')"
        prepend-inner-icon="mdi-map-marker"
        outlined
        required
        :rules="[reglas.required($t('primero.field_5'))]"
        :items="paises_carga"
        v-model="modelo.pais"
      />
    </v-col>
    <v-col cols="12" offset-sm="1" sm="4">
      <v-text-field
        :label="$t('primero.field_6')"
        prepend-inner-icon="mdi-earth"
        outlined
        required
        v-model="modelo.pagina"
      />
    </v-col>
  </v-row>
</template>

<script>
import paises from '../assets/paises.json'
export default {
  name: "First",
  props: {
    reglas: {
      type: Object,
      default: () => {},
    },
    modelo: {
      type: Object,
      default: () => {},
    }
  },
  computed : {
    paises_carga(){
      return paises.countries
    }
  }
};
</script>

<style></style>
